export default "__VITE_ASSET__cf684375__"